import axios from "axios";
import "./SantanderFilter";

const opcaoNaoAutorizada = "Opção não autorizada";
const falhaNaAutenticacao = "FALHA NA AUTENTICACAO";
const respostaPadraoErroGenerico =
    "Não foi possível devolver uma resposta, tente novamente com parâmetros diferentes.";
const respostaPadraoErroGenericoParcela =
    "Não foi possível calcular o valor da parcela para os parâmetros informados.";

const SantanderMixing = {
    data() {
        return {
            formSimulacao: {
                agencia: new this.$formInput(false),
                conta: new this.$formInput(false),
                digito: new this.$formInput(false),
                cupom: new this.$formInput(false),
                valor: new this.$formInput(false),
                parcela: new this.$formInput(true),
                forma: new this.$formInput(true),
                flex: new this.$formInput(false),
                firstInstallmentMinimumDate: null,
                firstInstallmentMaximumDate: null,
                valorEntrada: new this.$formInput(false),
                valorEntrada2: new this.$formInput(false),
                valorParcela: new this.$formInput(false),
                valorEntrada2Step: 100,
                valorEntrada2Max: 0,
                valorEntradaDigitando: false,
                valorLiberado: new this.$formInput(false),
                firstInstallment: new this.$formInput(true),
                attemptSubmit: false,
                showForm: true,
            },

            sm_optionsFormaPagamento: [],
            sm_optionsParcela: [],
            sm_optionsFlex: [],
            sm_optionsCliente: [],
            sm_tokenSantander: null,
            sm_tabId: null,
            sm_uuidTab: null,
            sm_uuidSimulation: null,
            sm_origem: this.origem,
            sm_codigoCliente: null,
            sm_codigoProduto: this.prd_codigo,
            sm_codigoPedido: null,
            sm_gravarPedido: false,
            sm_resultadoPreAnalise: null,
            sm_resultadoSimulacao: null,
            sm_processandoAtxResponse: false,
            sm_timeout: null,
            sm_verificarConta: false,
            sm_paymentFormId: null,
            valorEntradaPonteSettingValues: false,
            cetBase64: null,
            cetHoraGerada: null,
        };
    },

    mounted() {
        this.axiosErrorHandler();
    },

    methods: {
        axiosErrorHandler: function() {
            axios.interceptors.response.use(
                function(response) {
                    return response;
                },
                function(error) {
                    if (error && !error.response && !error.status) {
                        swal({
                            title: ":(",
                            text: "Serviço indisponível ou sem conexão com a internet.",
                            timer: 2000,
                        });
                        return Promise.reject(error);
                    }
                    return error;
                }
            );
        },
        clearMixingData: function() {
            this.sm_optionsFormaPagamento = [];
            this.sm_optionsParcela = [];
            this.sm_optionsFlex = [];
            //this.sm_optionsCliente = [];
            localStorage.token = null;
            localStorage.token_expires_in = null;
            this.sm_tokenSantander = null;
            this.sm_tabId = null;
            this.sm_uuidTab = null;
            this.sm_uuidSimulation = null;
            this.sm_origem = this.origem;
            this.sm_codigoCliente = null;
            this.sm_codigoProduto = this.prd_codigo;
            this.sm_codigoPedido = null;
            this.sm_gravarPedido = false;
            this.sm_resultadoPreAnalise = null;
            this.sm_resultadoSimulacao = null;
            this.sm_processandoAtxResponse = false;
            this.sm_timeout = null;
        },

        async reAutenticar() {
            let t = await this.getToken(true);
            if (!t) return false;

            return await this.getTab();
        },

        async reEnviarPreAnalise() {
            let r = await this.reAutenticar();
            if (!r) return false;

            await this.postPreAnalise(true);
        },

        async reEnviarSimulacao(salvarPdfCet = false) {
            let r = await this.reEnviarPreAnalise();
            if (!r) return false;

            await this.postSimulacao(true, salvarPdfCet);
        },

        async baixarOrcamentoCet() {
            if (!this.cetBase64) await this.getOrcamentoCet();

            if (!this.cetBase64) return;

            const linkSource = `data:application/pdf;base64,${this.cetBase64}`;
            const downloadLink = document.createElement("a");
            const fileName = `orcamento_cet_${this.cetHoraGerada
                .substring(0, 16)
                .replace(":", "")}.pdf`;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        },

        async getOrcamentoCet() {
            this.cetBase64 = null;
            this.cetHoraGerada = null;

            let self = this;
            self.loader = true;
            self.orcCetbtnEnabled = false;
            return await axios
                .post(
                    self.$apiUrl + "/Santander.svc/GetOrcamentoCet", {
                        token: self.sm_tokenSantander,
                        uuid: self.sm_uuidSimulation,
                        origem: self.sm_origem,
                        cli_codigo: self.sm_codigoCliente == null ?
                            null : self.sm_codigoCliente.toString().split("-")[0],
                        prd_codigo: self.sm_codigoProduto == null ?
                            null : self.sm_codigoProduto.toString().split("-")[0],
                        codigoPedido: self.sm_codigoPedido == null ?
                            null : self.sm_codigoPedido.toString().split("-")[0],
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    if (response.data.error != null && response.data.error.code == 401) {
                        let t = await self.getToken(true);
                        if (!t) return false;

                        return await self.baixarOrcamentoCet();
                    }
                    if (response.data.result.base64) {
                        this.cetBase64 = response.data.result.base64;
                        this.cetHoraGerada = response.data.result.horaGerada;
                    }
                })
                .finally(() => {
                    self.loader = false;
                    self.orcCetbtnEnabled = true;
                });
        },

        setParcelas() {
            this.sm_optionsParcela.splice(0);
            this.sm_resultadoPreAnalise.atxResponse.terms.forEach((item) => {
                let parcela = {};
                parcela.code = item.times;
                parcela.label = item.times + " x";
                //parcela.text = parcela.label;
                //parcela.value = parcela;
                this.sm_optionsParcela.push(parcela);
            });
            if (this.sm_optionsParcela.length > 0)
                this.formSimulacao.parcela.value = this.sm_optionsParcela[
                    this.sm_optionsParcela.length - 1
                ];
        },

        setFormasDePagamento() {
            this.sm_optionsFormaPagamento.splice(0);
            this.sm_resultadoPreAnalise.atxResponse.paymentForms.forEach((item) => {
                let forma = {};
                forma.code = item.id;
                forma.label = item.description;
                //forma.text = forma.label;
                //forma.value = forma;
                this.sm_optionsFormaPagamento.push(forma);
            });

            if (this.isAccountHolder) {
                this.formSimulacao.forma.value = this.getDebitoContaItem;
            } else {
                this.formSimulacao.forma.value = this.getBoletoItem;
            }
        },

        setFlex() {
            this.sm_optionsFlex.splice(0);
            if (this.sm_resultadoPreAnalise.atxResponse.flexPackages) {
                let flex = {};
                flex.code = null;
                flex.label = "PADRÃO";
                //flex.text = flex.label;
                //flex.value = flex;
                this.sm_optionsFlex.push(flex);
                this.sm_resultadoPreAnalise.atxResponse.flexPackages.forEach((item) => {
                    let flex = {};
                    flex.code = item.id;
                    flex.label = item.description + " x";
                    //flex.text = flex.label;
                    //flex.value = flex;
                    this.sm_optionsFlex.push(flex);
                });
                this.formSimulacao.flex.value = this.sm_optionsFlex[0];
            }
        },

        setUuid() {
            if (this.sm_resultadoPreAnalise.uuid) {
                this.sm_uuidSimulation = this.sm_resultadoPreAnalise.uuid;
            }
        },

        setDataPrimeiraParcela() {
            this.formSimulacao.firstInstallment.value = this.sm_resultadoPreAnalise.atxResponse.firstInstallment.recommendedDate;
            this.formSimulacao.firstInstallmentMinimumDate = this.sm_resultadoPreAnalise.atxResponse.firstInstallment.minimumDate;
            this.formSimulacao.firstInstallmentMaximumDate = this.sm_resultadoPreAnalise.atxResponse.firstInstallment.maximumDate;
        },

        setValorParcela: function() {
            this.formSimulacao.valorParcela.value = this.sm_resultadoSimulacao.simulationResponse.installmentValue;
            this.formSimulacao.valorLiberado.value = this.sm_resultadoSimulacao.simulationResponse.releasedValue;
        },

        getClientes() {
            let self = this;
            self.loader = true;

            self.sm_optionsCliente.splice(0);
            axios
                .get(this.$apiUrl + "Santander.svc/GetClientesPreAnalise", {
                    withCredentials: true,
                })
                .then((response) => {
                    let clientes = response.data;
                    clientes.forEach((element) => {
                        let item = {};
                        item.code = element.clientCode;
                        item.label = element.name;
                        //item.text = item.label;
                        item.document = element.document;
                        item.dateOfBirthFoundation = element.dateOfBirthFoundation;
                        item.cellPhone = element.cellPhone;
                        //item.value = item;
                        self.sm_optionsCliente.push(item);
                    });
                })
                .finally(() => {
                    self.loader = false;
                });
        },

        async getCliente(codigo) {
            let self = this;
            return await axios
                .post(self.$apiUrl + "Santander.svc/GetCliente", {
                    cli_codigo: codigo,
                })
                .then((response) => {
                    let cliente = response.data;
                    if (cliente) {
                        return cliente;
                    } else {
                        return false;
                    }
                });
        },

        getCurrentTimestamp() {
            return Math.round(+new Date());
        },

        async getToken(forceNew = false, noWarning = false) {
            let currentTimestamp = this.getCurrentTimestamp();
            let self = this;
            if (
                forceNew ||
                !this.sm_tokenSantander ||
                !localStorage.token ||
                (localStorage.token &&
                    localStorage.token_expires_in &&
                    localStorage.token_expires_in <= currentTimestamp)
            ) {
                self.loader = true;
                return await axios
                    .post(
                        this.$apiUrl + "Santander.svc/GetToken", {
                            gravarPedido: self.sm_gravarPedido,
                        }, { withCredentials: true }
                    )
                    .then((response) => {
                        if (response.data.error != null) {
                            if (noWarning) return false;
                            swal({
                                title: "Aviso",
                                text: response.data.error.code == 0 ?
                                    response.data.error.message : "Não foi possível executar essa ação, serviço indisponível, tente novamente mais tarde.",
                                icon: "warning",
                            });
                            return false;
                        }

                        let token = response.data.result.access_token;
                        self.sm_tokenSantander = token;
                        localStorage.token = token;
                        localStorage.token_expires_in = response.data.result.expires_in;

                        return true;
                    })
                    .finally(() => {
                        self.loader = false;
                    });
            } else {
                this.sm_tokenSantander = localStorage.token;
                return true;
            }
        },

        async getTab() {
            let self = this;
            self.loader = true;
            return await axios
                .post(
                    this.$apiUrl + "Santander.svc/GetTab", {
                        token: self.sm_tokenSantander,
                        origem: this.sm_origem,
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    if (response.data.error != null && response.data.error.code == 401) {
                        let t = await self.getToken(true, true);
                        if (!t) return false;

                        return await self.getTab();
                    }

                    let sistemaTab = response.data.result;
                    if (sistemaTab.tabId != 0) {
                        self.sm_tabId = sistemaTab.tabId;
                        self.sm_uuidTab = sistemaTab.uuid;
                        return true;
                    } else return false;
                })
                .finally(() => {
                    self.loader = false;
                });
        },

        async postPreAnalise(refreshUuIdOnly = false) {
            let self = this;
            self.loader = true;
            return await axios
                .post(
                    this.$apiUrl + "Santander.svc/PreAnalise", {
                        cli_codigo: self.sm_codigoCliente == null ?
                            null : self.sm_codigoCliente.toString().split("-")[0],
                        prd_codigo: self.sm_codigoProduto == null ?
                            null : self.sm_codigoProduto.toString().split("-")[0],
                        codigoPedido: self.sm_codigoPedido == null ?
                            null : self.sm_codigoPedido.toString().split("-")[0],
                        idTab: self.sm_tabId,
                        token: self.sm_tokenSantander,
                        documentoCliente: self.formPreAnalise.documentoCliente.value.replace(
                            /[\(\)\.\s-/]+/g,
                            ""
                        ),
                        dataNascimentoFundacao: self.formPreAnalise.dataNasc.value,
                        origem: self.sm_origem,
                        telefone: self.formPreAnalise.telefone.value.replace(
                            /[\(\)\.\s-]+/g,
                            ""
                        ),
                        installmentValue: self.formPreAnalise.valorSimular.value,
                        uuid: self.sm_uuidTab,
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    if (response.data.result != null) {
                        self.sm_resultadoPreAnalise = response.data.result;
                        self.ProcessarAtxResponse(refreshUuIdOnly);
                        return true;
                    } else {
                        if (
                            response.data.error &&
                            response.data.error.code == 401 &&
                            (await self.reAutenticar())
                        )
                            return await self.postPreAnalise(refreshUuIdOnly);

                        if (
                            response.data.error &&
                            response.data.error.code == 500 &&
                            response.data.error.message == falhaNaAutenticacao
                        )
                            return await self.reEnviarPreAnalise();

                        let error = response.data.error;
                        if (
                            response.data.error.code == 500 &&
                            response.data.error.message == opcaoNaoAutorizada
                        )
                            error.message =
                            "Não há resultado para os parâmetros escolhidos, mude os parâmetros e tente novamente.";

                        if (error.message == "DT NASCIMENTO INVALIDO") {
                            error.message = "Data de Nascimento/Fundação inválida.";
                        }

                        swal({
                            title: "Aviso",
                            text: error.message.replace("customer:", ""),
                            icon: "warning",
                        });
                    }
                    return false;
                })
                .catch(() => {
                    swal({
                        title: "Aviso",
                        text: respostaPadraoErroGenerico,
                        icon: "warning",
                    });
                    return false;
                })
                .finally(() => {
                    self.loader = false;
                });
        },

        ProcessarAtxResponse: function(refreshUuIdOnly) {
            this.sm_processandoAtxResponse = true;
            this.setUuid();
            if (!refreshUuIdOnly) {
                this.setParcelas();
                this.setDataPrimeiraParcela();
                this.setFormasDePagamento();
                this.setFlex();
            }
            this.sm_processandoAtxResponse = false;
        },

        async postSimulacao(localLoader = false, salvarPdfCet = false) {
            let self = this;

            if (
                self.sm_resultadoPreAnalise == null ||
                self.sm_resultadoPreAnalise.atxResponse == null
            )
                return false;

            if (localLoader) self.loaderStep2 = true;
            else self.loader = true;

            return await axios
                .post(
                    this.$apiUrl + "Santander.svc/Simulacao", {
                        token: self.sm_tokenSantander,
                        tableNumber: self.sm_resultadoPreAnalise.atxResponse.priceTable,
                        uuid: self.sm_uuidSimulation,
                        document: self.formPreAnalise.documentoCliente.value.replace(
                            /[\(\)\.\s-/]+/g,
                            ""
                        ),
                        downPayment: self.formSimulacao.valorEntrada.value,
                        firstPaymentDate: self.formSimulacao.firstInstallment.value,
                        installmentAmount: self.formSimulacao.parcela.value.code,
                        modality: self.formSimulacao.flex.value != null &&
                            self.formSimulacao.flex.value.code != null &&
                            self.formSimulacao.flex.value.code != "" ?
                            "90" : "P",
                        flexPackages: self.formSimulacao.flex.value != null &&
                            self.formSimulacao.flex.value.code != null &&
                            self.formSimulacao.flex.value.code != "" ?
                            self.formSimulacao.flex.value.code : null,
                        coupon: self.formSimulacao.cupom.value != null &&
                            self.formSimulacao.cupom.value != "" ?
                            self.formSimulacao.cupom.value : null,
                        paymentFormId: self.sm_paymentFormId,
                        totalValue: self.formSimulacao.valor.value,
                        tcFee: self.sm_resultadoPreAnalise.atxResponse.fees.tcFee,
                        tabFee: self.sm_resultadoPreAnalise.atxResponse.fees.tabFee,
                        tcExemption: self.sm_resultadoPreAnalise.atxResponse.fees.tcExemption,
                        agency: self.formSimulacao.agencia.value != null &&
                            self.formSimulacao.agencia.value != "" ?
                            self.formSimulacao.agencia.value : null,
                        account: self.formSimulacao.conta.value != null &&
                            self.formSimulacao.conta.value != "" ?
                            self.formSimulacao.conta.value : null,
                        digit: self.formSimulacao.digito.value != null &&
                            self.formSimulacao.digito.value != "" ?
                            self.formSimulacao.digito.value : null,
                        origem: self.sm_origem,
                        prd_codigo: self.sm_codigoProduto == null ?
                            null : self.sm_codigoProduto.toString().split("-")[0],
                        cli_codigo: self.sm_codigoCliente == null ?
                            null : self.sm_codigoCliente.toString().split("-")[0],
                        codigoPedido: self.sm_codigoPedido == null ?
                            null : self.sm_codigoPedido.toString().split("-")[0],
                        telefone: self.formPreAnalise.telefone.value.replace(
                            /[\(\)\.\s-]+/g,
                            ""
                        ),
                        dataNascimentoFundacao: self.formPreAnalise.dataNasc.value,
                        salvarPdfCet: salvarPdfCet,
                        verificarConta: self.sm_verificarConta,
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    if (response.data.result != null) {
                        if (response.data.result.simulationResponse.installmentValue == 0) {
                            swal({
                                title: "Aviso",
                                text: respostaPadraoErroGenericoParcela,
                                icon: "warning",
                            });
                            return false;
                        }

                        self.sm_resultadoSimulacao = response.data.result;
                        // if (response.data.result.atxResponse != null) {
                        //   self.sm_resultadoPreAnalise = {
                        //     atxResponse: response.data.result.atxResponse,
                        //   };
                        //   self.ProcessarAtxResponse();
                        //   await self.recalcularValorParcela();
                        //   return true;
                        // }

                        self.cetBase64 = response.data.result.CetPdfBase64;
                        self.cetHoraGerada = response.data.result.CetHoraGerada;

                        self.setValorParcela();
                        return true;
                    } else {
                        if (response.data.error && response.data.error.code == 401) {
                            return await self.reEnviarSimulacao(salvarPdfCet);
                        }

                        if (
                            response.data.error &&
                            response.data.error.code == 400 &&
                            response.data.error.message.includes("uuid")
                        ) {
                            return await self.reEnviarSimulacao(salvarPdfCet);
                        }

                        let error = response.data.error;
                        if (response.data.error.code == 500) {
                            if (
                                response.data.error.message.toLower().includes("token") ||
                                response.data.error.message.toLower().includes("autenticacao")
                            ) {
                                await self.reAutenticar();
                                await self.postPreAnalise(true);
                                return await self.postSimulacao(localLoader, salvarPdfCet);
                            }

                            if (response.data.error.message == opcaoNaoAutorizada) {
                                error.message = respostaPadraoErroGenerico;
                            }
                        }

                        swal({
                            title: "Aviso",
                            text: error.message.replace("customer:", ""),
                            icon: "warning",
                        });
                    }
                    return false;
                })
                .catch(() => {
                    swal({
                        title: "Aviso",
                        text: respostaPadraoErroGenerico,
                        icon: "warning",
                    });
                    return false;
                })
                .finally(() => {
                    if (localLoader) self.loaderStep2 = false;
                    else self.loader = false;
                });
        },

        removeAcento(text) {
            text = text.toLowerCase();
            text = text.replace(new RegExp("[ÁÀÂÃ]", "gi"), "a");
            text = text.replace(new RegExp("[ÉÈÊ]", "gi"), "e");
            text = text.replace(new RegExp("[ÍÌÎ]", "gi"), "i");
            text = text.replace(new RegExp("[ÓÒÔÕ]", "gi"), "o");
            text = text.replace(new RegExp("[ÚÙÛ]", "gi"), "u");
            text = text.replace(new RegExp("[Ç]", "gi"), "c");
            return text;
        },

        async getCepInfos(cep) {
            let self = this;
            self.loader = true;

            cep = cep.replace(/-/g, "");
            return await axios.get(`https://viacep.com.br/ws/${cep}/json/`)
                .then((response) => {
                    let cep = response.data;
                    if (cep.erro) {
                        swal({
                            title: "Aviso",
                            text: "O CEP informado não é válido.",
                            icon: "warning",
                        });
                        return null;
                    }

                    cep.logradouro = this.removeAcento(cep.logradouro).toUpperCase();
                    cep.bairro = this.removeAcento(cep.bairro).toUpperCase();
                    cep.uf = cep.uf.toUpperCase()
                    cep.localidade = this.removeAcento(cep.localidade).toUpperCase();
                    return cep;
                }).catch(() => {
                    swal({
                        title: "Aviso",
                        text: respostaPadraoErroGenerico,
                        icon: "warning",
                    });
                    return null;
                })
                .finally(() => {
                    self.loader = false;
                });
        },

        async postContato(formContato) {
            let self = this;
            self.loader = true;

            return await axios
                .post(
                    this.$apiUrl + "Santander.svc/Contato", {
                        nome: formContato.nome.value,
                        documento: self.formPreAnalise.documentoCliente.value.replace(
                            /[\(\)\.\s-/]+/g,
                            ""
                        ),
                        dataNascimento: self.formPreAnalise.dataNasc.value,
                        telefone: self.formPreAnalise.telefone.value.replace(
                            /[\(\)\.\s-]+/g,
                            ""
                        ),
                        email: formContato.email.value,
                        cep: formContato.cep.value.replace(/[-]+/g, ""),
                        uf: formContato.uf.value,
                        cidade: formContato.cidade.value,
                        prd_codigo: self.sm_codigoProduto == null ?
                            null : self.sm_codigoProduto.toString().split("-")[0],
                        sIMULACAO_SANTANDER_ID: this.sm_resultadoSimulacao.simulationResponse.SIMULACAO_SANTANDER_ID,
                        origem: self.sm_origem
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    if (response.data.result != null) {
                        return response.data.result.executou;
                    } else {
                        let error = response.data.error;
                        swal({
                            title: "Aviso",
                            text: error.message,
                            icon: "warning",
                        });
                    }
                    return false;
                })
                .catch(() => {
                    swal({
                        title: "Aviso",
                        text: respostaPadraoErroGenerico,
                        icon: "warning",
                    });
                    return false;
                })
                .finally(() => {
                    self.loader = false;
                });
        },

        async preAnalisar() {
            this.formPreAnalise.attemptSubmit = true;
            if (this.formPreAnaliseErrors !== 0) return false;

            if (!this.sm_tokenSantander || this.sm_tokenSantander == "") return false;

            await this.getTab();
            if (!this.sm_tabId || this.sm_tabId == "" || this.sm_tabId == 0)
                return false;

            return await this.postPreAnalise();
        },

        async simular(localLoader = false, salvarPdfCet = false) {
            if (this.isAccountHolder) {
                if (!this.isDebitoEmConta) {
                    this.sm_paymentFormId = this.getDebitoContaItem.code;
                    let result = await this.postSimulacao(localLoader, false);
                    this.sm_paymentFormId = this.getBoletoItem.code;
                    if (!result)
                        return false;
                }
            }

            if (salvarPdfCet) {
                this.exigirConta(this, this.isDebitoEmConta);
            }

            this.formSimulacao.attemptSubmit = true;
            if (this.formSimulacaoErrors !== 0) return false;

            if (!this.sm_tokenSantander || this.sm_tokenSantander == "") return false;

            if (!this.sm_tabId || this.sm_tabId == "" || this.sm_tabId == 0)
                return false;

            return await this.postSimulacao(localLoader, salvarPdfCet);
        },

        exigirConta(self, exigir) {
            self.formSimulacao.agencia.required = exigir;
            self.formSimulacao.conta.required = exigir;
            self.formSimulacao.digito.required = exigir;
            self.sm_verificarConta = exigir;
            this.formSimulacao.attemptSubmit = exigir;
        },

        async recalcularValorParcela() {
            let self = this;
            if (self.currentStep != 2) return;
            if (self.sm_processandoAtxResponse) return;
            self.formSimulacao.valorParcela.value = 0;

            if (self.sm_timeout != null) clearTimeout(self.sm_timeout);
            self.sm_timeout = setTimeout(async function() {
                self.formSimulacao.attemptSubmit = true;
                if (self.formSimulacaoErrors !== 0)
                    return;
                self.simular(true);
            }, 1000);
        },

        entrouCampoEntrada: function() {
            this.formSimulacao.valorEntradaDigitando = true;
            this.formSimulacao.valorEntrada2Step = 0.01;
        },

        saiuCampoEntrada: function() {
            this.formSimulacao.valorEntradaDigitando = false;
        },
    },

    computed: {
        getTipoCliente: function() {
            if (this.sm_optionsCliente && this.sm_optionsCliente.length > 0)
                return [
                    { code: 1, label: "CPF", value: "cpf" },
                    { code: 2, label: "CNPJ", value: "cnpj" },
                    { code: 3, label: "Seu Cliente", value: "revenda" },
                ];
            else
                return [
                    { code: 1, label: "CPF", value: "cpf" },
                    { code: 2, label: "CNPJ", value: "cnpj" },
                ];
        },

        contaBancariaString: function() {
            return (
                (this.formSimulacao.agencia.value != null &&
                    this.formSimulacao.agencia.value != "" ?
                    this.formSimulacao.agencia.value :
                    "") +
                (this.formSimulacao.conta.value != null &&
                    this.formSimulacao.conta.value != "" ?
                    this.formSimulacao.conta.value :
                    "") +
                (this.formSimulacao.digito.value != null &&
                    this.formSimulacao.digito.value != "" ?
                    this.formSimulacao.digito.value :
                    "")
            );
        },

        simulacaoParatrosString: function() {
            return (
                this.contaBancariaString +
                this.valorEntradaPonte +
                (this.formSimulacao.parcela.value &&
                    this.formSimulacao.parcela.value.code ?
                    this.formSimulacao.parcela.value.code :
                    "") +
                (this.formSimulacao.firstInstallment.value ?
                    this.formSimulacao.firstInstallment.value :
                    "") +
                (this.formSimulacao.forma.value && this.formSimulacao.forma.value.code ?
                    this.formSimulacao.forma.value.code :
                    "") +
                (this.formSimulacao.flex.value && this.formSimulacao.flex.value.code ?
                    this.formSimulacao.flex.value.code :
                    "")
            );
        },

        getBoletoItem: function() {
            let index = this.sm_optionsFormaPagamento.findIndex((x) => x.code == 9);
            if (index == -1) return null;

            return this.sm_optionsFormaPagamento[index];
        },

        getDebitoContaItem: function() {
            let index = this.sm_optionsFormaPagamento.findIndex((x) => x.code == 10);
            if (index == -1) return null;

            return this.sm_optionsFormaPagamento[index];
        },

        formPreAnaliseErrors: function() {
            const errors = Object.keys(this.formPreAnalise).filter(
                (key) =>
                this.formPreAnalise[key].validation &&
                !this.formPreAnalise[key].validation.status
            );
            return errors.length;
        },

        formSimulacaoErrors: function() {
            const errors = Object.keys(this.formSimulacao).filter(
                (key) =>
                this.formSimulacao[key].validation &&
                !this.formSimulacao[key].validation.status
            );
            return errors.length;
        },

        isDebitoEmConta: function() {
            return this.formSimulacao.forma.value == this.getDebitoContaItem;
        },

        isAccountHolder: function() {
            if (this.sm_resultadoPreAnalise == null)
                return false;

            if (this.sm_resultadoPreAnalise.atxResponse == null)
                return false;

            if (this.sm_resultadoPreAnalise.atxResponse.accountHolder == null)
                return false;

            return this.sm_resultadoPreAnalise.atxResponse.accountHolder;
        },

        temFlex: function() {
            return (
                this.sm_optionsFlex.length > 0 &&
                this.formSimulacao.forma.value.code == 10
            );
        },
    },

    watch: {
        "formSimulacao.forma.value": function() {
            if (this.formSimulacao.forma.value != null)
                this.sm_paymentFormId = this.formSimulacao.forma.value.code;

            if (this.sm_optionsFlex.length > 0)
                this.formSimulacao.flex.value = this.sm_optionsFlex[0];

            if (!this.isDebitoEmConta) {
                this.formSimulacao.attemptSubmit = false;
                this.formSimulacao.agencia.required = false;
                this.formSimulacao.conta.required = false;
                this.formSimulacao.digito.required = false;
                this.formSimulacao.agencia.value = "";
                this.formSimulacao.conta.value = "";
                this.formSimulacao.digito.value = "";
                this.formSimulacao.agencia.validation.status = true;
                this.formSimulacao.conta.validation.status = true;
                this.formSimulacao.digito.validation.status = true;
                this.sm_verificarConta = false;
            }
        },

        simulacaoParatrosString: function() {
            this.recalcularValorParcela();
        },

        "formSimulacao.valorEntrada.value": function(val) {
            if (this.valorEntradaPonteSettingValues) return;

            this.valorEntradaPonte = parseFloat(val);
        },

        "formSimulacao.valorEntrada2.value": function(val) {
            if (this.valorEntradaPonteSettingValues) return;

            this.valorEntradaPonte = parseFloat(val);

            if (this.formSimulacao.valorEntradaDigitando) return;

            if (
                this.valorEntradaPonte + this.valorEntradaPonte * 0.1 >
                this.formSimulacao.valorEntrada2Max
            ) {
                this.formSimulacao.valorEntrada2Step = 0.01;
            } else {
                this.formSimulacao.valorEntrada2Step = 100;
            }
        },

        valorEntradaPonte: function(val) {
            this.valorEntradaPonteSettingValues = true;
            this.formSimulacao.valorEntrada.value = val;
            this.formSimulacao.valorEntrada2.value = val;
            this.formSimulacao.valorLiberado.value =
                this.formSimulacao.valor.value - val;
            this.valorEntradaPonteSettingValues = false;
        },
    },
};
export default SantanderMixing;